export function formatCurrency(cents: number, locale: string): string {
  const currency = locale === 'pt-BR' ? 'BRL' : 'USD';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(cents / 100);
}
